<template>
    <div :class="`the-relay-sip-endpoint-widget-global-wrapper ${isMobile ? 'the-relay-sip-endpoint-widget-global-wrapper--mobile' : ''}`"
         v-show="show"
    >
        <transition name="fade">
            <div :class="`sip-endpoint-widget__controls-wrapper ${(isMobile && !isSessionIsNull) ? 'sip-endpoint-widget__controls-wrapper--mobile' : ''}`"
                 v-if="isRegistered && isConversationAssigned"
            >
                <div :class="`sip-endpoint-widget__button sip-endpoint-widget__call-button ${!isAssignedAgentOnline ? 'sip-endpoint-widget__call-button--inactive' : ''}`"
                     v-if="isSessionIsNull"
                     @click="makeCall(false)"
                >
                    <img src="~dashboard/assets/images/phone.svg" alt="Call" width="20px" height="20px">
                </div>

                <div :class="`sip-endpoint-widget__button sip-endpoint-widget__call-button ${!isAssignedAgentOnline ? 'sip-endpoint-widget__call-button--inactive' : ''}`"
                     v-if="isSessionIsNull && !isMobile"
                     @click="makeCall(true)"
                >
                    <img src="~/dashboard/assets/images/monitor-share.svg" alt="Call" width="20px" height="20px">
                </div>

                <div :class="`sip-endpoint-widget__button  ${isAudioMuted ? 'sip-endpoint-widget__mute-audio-button--active' : 'sip-endpoint-widget__mute-audio-button'}`"
                     v-if="isEstablished || isOutgoing"
                     @click="toggleAudioMute"
                >
                    <img :src="isAudioMuted ? require(`../../../dashboard/assets/images/microphone-off.svg`) : require(`../../../dashboard/assets/images/microphone.svg`)"
                         alt="Microphone Icon"
                         width="20px" height="20px"
                    >
                </div>

                <div :class="`sip-endpoint-widget__button  ${(isVideoMuted || !isEstablished) ? 'sip-endpoint-widget__mute-audio-button--active' : 'sip-endpoint-widget__mute-audio-button'}`"
                     v-if="((isEstablished || isOutgoing) && isVideoAvailable && !isScreenShare)"
                     @click="toggleVideoMute"
                >
                    <img :src="(isVideoMuted || !isEstablished) ? require(`../../../dashboard/assets/images/video-off.svg`) : require(`../../../dashboard/assets/images/video.svg`)"
                         alt="Camera Icon"
                         width="20px" height="20px"
                    >
                </div>

                <div :class="`sip-endpoint-widget__button  ${(isVideoMuted || !isEstablished) ? 'sip-endpoint-widget__mute-audio-button--active' : 'sip-endpoint-widget__mute-audio-button'}`"
                     v-if="((isEstablished || isOutgoing) && isVideoAvailable && isScreenShare)"
                     @click="toggleVideoMute"
                >
                    <img :src="(isVideoMuted || !isEstablished) ? require(`../../../dashboard/assets/images/monitor-off.svg`) : require(`../../../dashboard/assets/images/monitor-share.svg`)"
                         alt="Camera Icon"
                         width="20px" height="20px"
                    >
                </div>

                <div class="sip-endpoint-widget__button sip-endpoint-widget__decline-button"
                     v-if="isEstablished || isOutgoing"
                     @click="terminate"
                >
                    <img src="~dashboard/assets/images/phone-hangup.svg"
                         alt="Decline"
                         width="20px" height="20px"
                    >
                </div>

            </div>
        </transition>

        <transition name="fade">
            <div class="incoming-call-wrapper"
                 v-if="!isEstablished && isIncoming && !isEnding"
            >
                <div class="incoming-call-box">
                    <div class="incoming-call-box__header">
                        Incoming Call
                    </div>

                    <div class="incoming-call-box__from">
                        <div class="incoming-call-box__from-inside">
                            {{companyName}}
                        </div>
                    </div>

                    <div class="incoming-call-box__actions">
                        <div class="incoming-call-box__button incoming-call-box__accept-button"
                             @click="answer"
                        >
                            <img src="~dashboard/assets/images/phone.svg" alt="Accept" width="32px" height="32px">
                        </div>

                        <div class="incoming-call-box__button incoming-call-box__decline-button"
                             @click="terminate"
                        >
                            <img src="~dashboard/assets/images/phone-hangup.svg" alt="Decline" width="32px" height="32px">
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <audio id="remote-audio"
               autoplay="autoplay"
        >
        </audio>

        <transition name="fade">
            <div :class="`${isMaximizedState ? 'self-video-wrapper--maximized' : ''} ${isSelfNormalState ? 'self-video-wrapper--normal' : ''} ${isSelfMinimizedState ? 'self-video-wrapper--minimized' : ''}`"
                 v-show="isVideoAvailable && !isVideoMuted"
                 :style="!isMaximizedState && isInnerSelf ? {bottom: `100px`, right: `20px`} : !isMaximizedState ? {top: `${selfVideoTop}px`, left: `${selfVideoLeft}px`} : {}"
                 @mousedown="moveSelfVideo"
            >
                <video id="self-view"
                      :class="`sip-endpoint-widget__self-view ${isSelfMinimizedState ? 'sip-endpoint-widget__self-view--minimized' : ''}`"
                       :style="isSelfMinimizedState ? {display: 'none'} : {}"
                       autoplay="autoplay"
                       muted="muted"
                       playsinline="playsinline"
                >
                </video>
                <div class="self-video__actions"
                     :style="isSelfMinimizedState || isSelfNormalState ? {justifyContent: 'flex-end'} : {}"
                >
                    <div class="self-video__action"
                         :style="isSelfMinimizedState ? {display: 'none'} : {}"
                         @click="minimizeSelfVideo"
                    >
                        <img src="~dashboard/assets/images/window-minimize.svg" alt="minimize">
                    </div>

                    <div class="self-video__action"
                         :style="isSelfNormalState ? {display: 'none'} : {}"
                         @click="toNormalSelfVideo"
                    >
                        <img src="~dashboard/assets/images/window-maximize.svg" alt="maximize">
                    </div>
                </div>
            </div>
        </transition>

<!--        <transition name="fade-remote-video">-->
            <div :class="`${isNormalState && !isMobile ? 'remote-video-wrapper--normal' : ''} ${isMinimizedState && !isMobile ? 'remote-video-wrapper--minimized' : ''} ${isMaximizedState && !isMobile ? 'remote-video-wrapper--maximized' : ''} ${isMobile ? 'remote-video-wrapper--maximized' : ''}`"
                 v-show="isVideoAvailable && remoteStream"
                 :style="!isMaximizedState && isInnerRemote ? {top: `60px`, left: `25%`} : !isMaximizedState ? {top: `${remoteVideoTop}px`, left: `${remoteVideoLeft}px`} : {}"
                 @mousedown="moveRemoteVideo"
            >
                <video id="remote-view"
                       :class="`sip-endpoint__remote-view ${isMinimizedState ? 'sip-endpoint__remote-view--minimized' : ''} ${isMaximizedState ? 'sip-endpoint__remote-view--maximized' : ''}`"
                       :style="isMaximizedState ? {width: `${innerWidth}px`, height: `${innerHeight}px`} : isNormalState ? {height: '390px'} : isMinimizedState ? {display: 'none'} : {}"
                       autoplay="autoplay"
                       muted="muted"
                       playsinline="playsinline"
                >
                </video>

                <div :class="`sip-endpoint__remote-view-off ${isMinimizedState ? 'sip-endpoint__remote-view-off--minimized' : ''} ${isMaximizedState ? 'sip-endpoint__remote-view-off--maximized' : ''}`"
                     :style="isAgentCameraOn ? {display : 'none'} : isMaximizedState ? {width: `${innerWidth}px`, height: `${innerHeight}px`} : isNormalState ? {height: '390px'} : isMinimizedState ? {display: 'none'} : {}">
                  <img src="~dashboard/assets/images/account.svg"  alt="video-off" >
                  {{companyName}}
                </div>

                <div :class="`remote-video__actions ${isMobile ? 'remote-video__actions--mobile' : ''}`"
                     :style="isMinimizedState ? {justifyContent: 'flex-end'} : {}"
                >
                    <div :class="`remote-video__action ${isMobile ? 'remote-video__action--mobile' : ''}`"
                         :style="isMinimizedState ? {display: 'none'} : {}"
                         @click="minimizeRemoteVideo"
                    >
                        <img src="~dashboard/assets/images/window-minimize.svg" alt="minimize" width="20px" height="20px">
                    </div>

                    <div :class="`remote-video__action ${isMobile ? 'remote-video__action--mobile' : ''}`"
                         @click="maximizedRemoteVideo"
                    >
                        <img src="~dashboard/assets/images/window-maximize" alt="maximize" width="20px" height="20px">
                    </div>
                </div>
            </div>
<!--        </transition>-->

        <transition name="fade">
            <div :class="`sip-endpoint__controls-wrapper ${isMaximizedState ? 'sip-endpoint__controls-wrapper--maximized' : ''} ${isMobile ? 'sip-endpoint__controls-wrapper--mobile' : ''}`"
                 v-if="isEstablished || isOutgoing"
            >
                <div class="sip-endpoint-dialog__established-controls">

                    <div :class="`established-controls__from ${isMobile ? 'established-controls__from--mobile' : ''}`">
                        {{companyName}}
                    </div>

                    <div class="established-controls__time">
                        {{new Date(this.seconds * 1000).toISOString().substr(11, 8)}}
                    </div>

                    <div class="established-controls__buttons-wrapper">
                        <div :class="`established-controls__mute-icon-wrapper ${isAudioMuted && isAssignedAgentOnline ? 'established-controls__mute-icon-wrapper--active' : ''}`"
                             @click="toggleAudioMute"
                        >
                            <img :src="isAudioMuted ? require(`../../../dashboard/assets/images/microphone-off.svg`) : require(`../../../dashboard/assets/images/microphone.svg`)" alt="Microphone Icon" width="32px" height="32">
                        </div>

                        <div :class="`established-controls__mute-icon-wrapper ${(isVideoMuted || !isEstablished) && isAssignedAgentOnline ? 'established-controls__mute-icon-wrapper--active' : ''}`"
                             @click="toggleVideoMute"
                        >
                            <img :src="(isVideoMuted || !isEstablished) && isAssignedAgentOnline ? require(`../../../dashboard/assets/images/video-off.svg`) : require(`../../../dashboard/assets/images/video.svg`)"
                                 alt="Video Icon" width="32px" height="32px"
                                 v-if="!isScreenShare"
                            >

                            <img :src="(isVideoMuted || !isEstablished) && isAssignedAgentOnline ? require(`../../../dashboard/assets/images/monitor-off.svg`) : require(`../../../dashboard/assets/images/monitor-share.svg`)"
                                 alt="Screen share Icon" width="32px" height="32px"
                                 v-if="isScreenShare"
                            >
                        </div>

                        <div class="established-controls__decline-icon-wrapper"
                             @click="terminate"
                        >
                            <img src="~dashboard/assets/images/phone-hangup.svg" alt="Decline" width="32px" height="32px">
                        </div>

                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

import adapter from 'webrtc-adapter';
import {ringtoneBase64} from "../../../dashboard/components/TheSIPEndpoint/ringtoneBase64";
import {beepsBase64} from "../../../dashboard/components/TheSIPEndpoint/beepsBase64";
import {callStatusTypes} from "../../../dashboard/components/TheSIPEndpoint/constants/callStatusTypes";
import {mapGetters} from "vuex";
import {sipEndpointAPI} from "../../api/sipEndpointAPI";
import {callsAPI} from "../../api/callsAPI";
import {callerTypes} from "./constants/callerTypes";
import {Relay} from "@signalwire/js";
import {selfVideoStateTypes} from "../../../dashboard/components/TheSIPEndpoint/constants/selfVideoStateTypes";
import {remoteVideoStateTypes} from "../../../dashboard/components/TheSIPEndpoint/constants/remoteVideoStateTypes";
import { IFrameHelper } from 'widget/helpers/utils';

function getQueryVariable(variable) {
    let query = window.location.search.substring(1);
    let vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) == variable) {
            return decodeURIComponent(pair[1]);
        }
    }
}

export default {
    name: "TheRelaySIPEndpointWidget",
    props: {
        show: {
            type: Boolean
        },
        isMobile: {
            type: Boolean
        }
    },
    data() {
        return {
            client: null,
            call: null,

            inboxId: null,
            conversationId: null,
            agentId: null,

            from: null,
            to: null,

            ringtone: null,
            beeps: null,

            intervalId: null,
            seconds: 0,

            firstRequestFlag: true,

            mySIPEndpoint: null,
            remoteAgentSIPEndpoint: null,

            callStatusType: null,
            callId: null,
            callSID: null,

            isIncoming: false,
            isOutgoing: false,

            isInit: false,

            isRegistered: false,

            initIntervalId: null,

            isVideoAvailable: false,

            isAudioMuted: false,
            isVideoMuted: true,

            isScreenShare: false,

            localStream: null,
            remoteStream: null,

            selfVideoState: null,
            remoteVideoState: null,

            innerHeight: 0,
            innerWidth: 0,
            isEnding: false,

            companyName: "",

            isInnerSelf: true,
            isInnerRemote: true,
            innerVideoTop: 0,
            innerVideoLeft: 0,
            remoteVideoTop: 60,
            remoteVideoLeft: 0,
            selfVideoTop: 0,
            selfVideoLeft: 0,
            activeRemote:false,
            activeSelf:false
        }
    },
    computed: {
        ...mapGetters({
            isAgentCameraOn: "conversation/getIsAgentCameraOn",
            userData: "sip/getUserData",
            agentData: "sip/getAgentData",
            videoData: "sip/getVideoData",
            sipFlag: "sip/getSipFlag",
            conversationAttributes: 'conversationAttributes/getConversationParams',
            conversations: "conversation/getConversation",
            conversationSize: "conversation/getConversationSize",
            availableAgents: "agent/availableAgents",
            isConversationAssigned: "conversationAssigned/getIsConversationAssigned"
        }),
        isInProgress() {
            if (this.call) {
                return ((this.call.state === "trying") || (this.call.state === "ringing"));
            }
            return false;
        },
        isEstablished() {
            if (this.call) {
                return this.call.state === "active";
            }
            return false;
        },
        isAssignedAgentOnline(){
          let agentsArr = this.availableAgents.map(agent => ({
            id: agent.id,
            name: agent.name,
          }));;
          let myAgent = agentsArr.find(agent => agent.id == this.agentId);
          if(myAgent){
            return true;
          }
          else{
            if(this.callStatusType == "in_progress"){
              this.terminate();
            }
            return false;
          }
        },
        isSessionIsNull() {
            return this.call === null;
        },
        isMySIPEndpointPresent() {
            return this.mySIPEndpoint !== null;
        },
        isSelfNormalState() {
          return this.selfVideoState === selfVideoStateTypes.NORMAL;
        },
        isSelfMinimizedState() {
            return this.selfVideoState === selfVideoStateTypes.MINIMIZED;
        },
        isNormalState() {
            return this.remoteVideoState === remoteVideoStateTypes.NORMAL;
        },
        isMinimizedState() {
            return this.remoteVideoState === remoteVideoStateTypes.MINIMIZED;
        },
        isMaximizedState() {
            return this.remoteVideoState === remoteVideoStateTypes.MAXIMIZED;
        }
    },
    watch: {
        isMobile: function (value) {
            if (value) {
                this.remoteVideoState = remoteVideoStateTypes.NORMAL;
            }
        }
    },
    mounted() {
        this.initIntervalId = setInterval(this.getContactSipEndpoint, 2000);
        this.innerWidth = window.innerWidth;
        this.innerHeight = window.innerHeight;

        window.addEventListener('mousemove', event=>{
          if(this.activeRemote){
            if(this.isInnerRemote){
              this.remoteVideoLeft = this.innerWidth/2 - 260 + event.clientX - this.innerVideoLeft;
              this.remoteVideoTop = this.remoteVideoTop + (event.clientY - this.innerVideoTop);
              this.innerVideoLeft = event.clientX;
              this.innerVideoTop = event.clientY;
              this.isInnerRemote = false;
            }
            else{
              this.remoteVideoLeft = this.remoteVideoLeft + event.clientX - this.innerVideoLeft;
              this.remoteVideoTop = this.remoteVideoTop + event.clientY - this.innerVideoTop;
              this.innerVideoLeft = event.clientX;
              this.innerVideoTop = event.clientY;
            }
          }
          if(this.activeSelf){
            if(this.isInnerSelf){
              this.selfVideoLeft = this.innerWidth - 180 + (event.clientX - this.innerVideoLeft);
              this.selfVideoTop = this.innerHeight - 220 + (event.clientY - this.innerVideoTop);
              this.innerVideoLeft = event.clientX;
              this.innerVideoTop = event.clientY;
              this.isInnerSelf = false;
            }
            else{
              this.selfVideoLeft = this.selfVideoLeft + (event.clientX - this.innerVideoLeft);
              this.selfVideoTop = this.selfVideoTop + (event.clientY - this.innerVideoTop);
              this.innerVideoLeft = event.clientX;
              this.innerVideoTop = event.clientY;
            }
          }
        });
        window.addEventListener('mouseup', event=>{
          this.activeRemote = false;
          this.activeSelf = false;
        });
    },
    beforeDestroy() {
        if (this.client) {
            this.client.disconnect();
        }

        clearInterval(this.initIntervalId);
    },
    methods: {
        onCameraOff() {
          this.toggleCamera('off');
        },
        onCameraOn() {
          this.toggleCamera('on');
        },
        toggleCamera(cameraStatus) {
          this.$store.dispatch('conversation/toggleUserCamera', { cameraStatus });
        },
        async getContactSipEndpoint() {
            if (!this.isInit) {
                let params = {};
                let params_2 = {};

                this.innerWidth = window.innerWidth;
                this.innerHeight = window.innerHeight;

                const properties = Object.getOwnPropertyNames(this.conversations);
                // params.conversation_id = this.conversations[properties[0]].conversation_id;
                // params.inbox_id = this.conversations[properties[0]].inbox_id;
                params.conversation_id = this.conversationAttributes.id
                params.inbox_id = this.conversationAttributes.inbox_id
                params.caller_type = callerTypes.CONTACT;
                if (!params.conversation_id || !params.inbox_id) {
                    return;
                }
                this.$store.commit("sip/setParamsSipUser", params);
                // params_2.conversation_id = this.conversations[properties[0]].conversation_id;
                // params_2.inbox_id = this.conversations[properties[0]].inbox_id;
                params_2.conversation_id = this.conversationAttributes.id
                params_2.inbox_id = this.conversationAttributes.inbox_id
                params_2.caller_type = callerTypes.USER;
                if (!params_2.conversation_id || !params_2.inbox_id) {
                    return;
                }
                this.$store.commit("sip/setParamsSipAgent", params_2);
                this.$store.commit("sip/setWebsiteToken", getQueryVariable("website_token"));
                this.inboxId = params.inbox_id;
                this.conversationId = params.conversation_id;
                if(this.firstRequestFlag){
                  this.firstRequestFlag = false;
                  this.$store.commit("sip/toogleStartFlag");
                  this.$store.dispatch('sip/fetchIsVideoAbailable');
                  this.$store.dispatch('sip/fetchAgentData');
                  this.$store.dispatch('sip/fetchUserData');
                }
                if (this.client === null) {
                    if(this.agentData.credentials && (this.userData.credentials.sip_username !== "")){
                      this.$store.commit("sip/toogleStartFlag");
                      this.isVideoAvailable = this.videoData.is_video_available;
                      if (this.videoData.is_conversation_assigned) {

                          if (!this.isConversationAssigned) {
                              this.$store.commit("conversationAssigned/toggleIsConversationAssigned");
                          }
                      }
                      this.agentId = this.agentData.credentials.agent_id;
                      this.mySIPEndpoint = this.userData.credentials;

                      this.companyName = this.userData.credentials.company_name;

                      const PROJECT_ID = "d5ed93de-1616-4886-9f61-3eb0323c3150";
                      const response_2 = await sipEndpointAPI.getToken(`${this.mySIPEndpoint.sip_username}`);

                      const JWT_TOKEN = response_2.data.jwt_token;
                      const client = new Relay({project: PROJECT_ID, token: JWT_TOKEN});

                      client.sip_username = `${this.mySIPEndpoint.sip_username}_RELAY`;
                      client.my_refresh_token = response_2.data.refresh_token;

                      client.on('signalwire.ready', this.onSignalwireReady);
                      client.on('signalwire.error', this.onSignalwireError);
                      client.on('signalwire.notification', async (e) => {
                          switch (e.type) {
                              case 'callUpdate':
                                  await this.onCallUpdate(e);

                                  break;
                              case 'userMediaError':
                                  this.onUserMediaError(e);

                                  break;
                              case "refreshToken":
                                  await this.onRefreshToken(client, e);

                                  break;
                              case "participantData":
                                  this.onParticipantData(e);

                                  break;
                          }
                      });
                      client.on('signalwire.socket.open', this.onSignalwireSocketOpen);
                      client.on('signalwire.socket.error', this.onSignalwireSocketError);
                      client.on('signalwire.socket.message', this.onSignalwireSocketMessage);
                      client.on('signalwire.socket.close', this.onSignalwireSocketClose);

                      client.localElement = "self-view";
                      client.remoteElement = "remote-view";

                      client.enableMicrophone();

                      if (this.isVideoAvailable) {
                          client.enableWebcam();
                      }

                      client.iceServers = [{
                          urls: "turn:turn.conversate.us:5349",
                          username: "conversate",
                          credential: "2261f857"
                      }];

                      await client.connect();

                      this.ringtone = new Audio(ringtoneBase64);
                      this.ringtone.loop = true;
                      this.beeps = new Audio(beepsBase64);
                      this.beeps.loop = true;

                      this.client = client;
                      this.isInit = true;

                      clearInterval(this.initIntervalId);
                    }
                    else {
                      if(!this.sipFlag){
                        this.$store.commit("sip/toogleSipFlag");
                      }
                    }
                }
            }
        },
        onSignalwireReady(e) {
            this.isRegistered = true;
        },
        onSignalwireError(e) {
        },
        onSignalwireSocketOpen(e) {
        },
        onSignalwireSocketError(e) {
        },
        onSignalwireSocketMessage(e) {
        },
        onSignalwireSocketClose(e) {
        },
        async onCallUpdate(e) {
            switch (e.call.state) {
                case 'new':
                    if (this.call) {
                        break;
                    }

                    this.call = e.call;
                    this.callStatusType = callStatusTypes.IN_PROGRESS;

                    break;
                case 'trying': // You are trying to call someone and he's ringing now
                    this.beeps.play();
                    this.call = e.call;
                    this.isOutgoing = true;
                    this.callSID = this.call.id;

                    const response = await callsAPI.createCall({
                        from: this.from,
                        to: this.to,
                        source_id: this.callSID,
                        status: callStatusTypes.IN_PROGRESS,
                        agent_id: this.agentId,
                        inbox_id: this.inboxId,
                        call_type: "inbound",
                        website_token: getQueryVariable("website_token"),
                        conversation_id: this.conversationId
                    });

                    this.callId = response.data.id;


                    break;
                case 'requesting':
                    this.call = e.call;
                    break;
                case 'recovering':
                    this.call = e.call;
                    break;
                case 'ringing': // Someone is calling you
                    if (this.call.id !== e.call.id) {
                        break;
                    }

                    if (IFrameHelper.isIFrame()) {
                        IFrameHelper.sendMessage({
                            event: 'openWidget',
                        });
                    }

                    this.from = this.call.options.remoteCallerName;
                    this.to = this.call.options.callerNumber;
                    this.call = e.call;
                    this.isIncoming = true;
                    this.ringtone.play();
                    break;
                case 'answering':
                    this.call = e.call;
                    break;
                case 'early':
                    if (this.call.id !== e.call.id) {
                        break;
                    }

                    this.call = e.call;
                    break;
                case 'active': // Call has become active
                    this.beeps.pause();
                    this.call = e.call;
                    this.localStream = e.call.localStream;
                    this.remoteStream = e.call.remoteStream;
                    this.remoteVideoState = remoteVideoStateTypes.NORMAL;
                    this.selfVideoState = selfVideoStateTypes.NORMAL;
                    this.intervalId = setInterval(this.updateSeconds, 1000);
                    if (this.isScreenShare) {
                      this.onCameraOn();
                      this.isVideoMuted = false;
                    } else {
                      this.call.muteVideo();
                    }
                    if (this.isOutgoing) {
                        try {
                            this.updateCall({
                                status: callStatusTypes.ANSWERED
                            });
                        } catch (e) {
                            console.log(e);
                        }
                    }

                    if (this.call.remoteStream) {
                        const remoteAudio = document.getElementById("remote-audio");
                        remoteAudio.srcObject = null;
                        remoteAudio.srcObject = this.call.remoteStream;
                    }

                    break;
                case 'held':
                    this.call = e.call;
                    break;
                case 'hangup': // Call is over
                    this.isEnding = true;
                    if (this.call.id !== e.call.id) {
                        break;
                    }

                    this.call = e.call;
                    break;
                case 'destroy': // Call has been destroyed
                    this.isEnding = true;
                    if (this.call.id !== e.call.id) {
                        break;
                    }

                    this.callStatusType = callStatusTypes.COMPLETED;
                    if (this.isOutgoing) {
                        try {
                            await this.updateCall({
                                status: this.callStatusType,
                                duration: this.seconds
                            });
                        } catch (e) {
                            console.log(e);
                        }
                    }

                    this.call = e.call;
                    this.cleanUp();
                    break;
                case 'purge':
                    this.call = e.call;
                    break;
            }
        },
        onUserMediaError(e) {
        },
        async onRefreshToken(client, e) {
            const response = await sipEndpointAPI.refreshToken(client.my_refresh_token);
            await client.refreshToken(response.data.jwt_token);
            client.my_refresh_token = response.data.refresh_token;
        },
        onParticipantData(e) {
            this.call = e.call;
        },
        onSignalwireNotification(e) {
            switch (e.type) {
                case 'callUpdate':
                    this.onCallUpdate(e);
                    break;
                case 'userMediaError':
                    this.onUserMediaError(e);
                    break;
                case "refreshToken":
                    this.onRefreshToken(e);
                    break;
                case "participantData":
                    this.onParticipantData(e);
                    break;
            }
        },
        async makeCall(isScreenShare) {
          if (this.availableAgents.length !== 0) {
                let params = {};
                // const properties = Object.getOwnPropertyNames(this.conversations);
                params.conversation_id = this.conversationAttributes.id
                params.inbox_id = this.conversationAttributes.inbox_id
                params.caller_type = callerTypes.USER;
                this.inboxId = params.inbox_id;
                this.conversationId = params.conversation_id;
                const response = await sipEndpointAPI.getSIPEndpoints({
                    sip: {
                        ...params
                    }
                });

                if (response.data.credentials && response.data.balance_positive) {
                    this.remoteAgentSIPEndpoint = response.data.credentials;
                    this.agentId = response.data.credentials.agent_id;
                    if (this.client) {
                        this.from = this.client.sip_username;
                        this.to = `${this.remoteAgentSIPEndpoint.sip_username}_RELAY`
                        this.startIceGatheringTimer(this.client.connection.session);
                        if (isScreenShare) {
                            this.isScreenShare = true;
                            try {
                                this.localStream = await navigator.mediaDevices.getDisplayMedia({audio: true, video: true});
                                const audioStream = await navigator.mediaDevices.getUserMedia({audio: true});
                                this.localStream.addTrack(audioStream.getAudioTracks()[0]);
                                this.call = await this.client.newCall({
                                    destinationNumber: `${this.remoteAgentSIPEndpoint.sip_username}_RELAY`,
                                    audio: true,
                                    video: this.isVideoAvailable,
                                    localStream: this.localStream
                                })
                            } catch (e) {
                              console.log(e)
                            }
                        } else {
                            try {
                                this.call = await this.client.newCall({
                                    destinationNumber: `${this.remoteAgentSIPEndpoint.sip_username}_RELAY`,
                                    audio: true,
                                    video: this.isVideoAvailable,
                                })
                            } catch (e) {
                            }
                        }
                    }
                }
              }
        },
        startIceGatheringTimer(session){
      			let timeoutFn = null;
      			let sdp = false;
      			session.on('icecandidate', (icecandidatedata) =>
      			{
      				if (!timeoutFn)
      				{
      					setTimeout(timeoutFn = function()
      					{
      						if (!sdp)
      						{
      							icecandidatedata.ready();
      						}
      					}, 5000);
      				}
      			});

      			session.on('sdp', (sdpdata) =>
      			{
      				if (sdpdata.originator == 'local')
      				{
      					sdp = true;
      				}
      			});
      	},
        async answer() {
            if (this.call) {
                this.startIceGatheringTimer(this.client.connection.session);
                this.call.answer();
                this.callStatusType = callStatusTypes.ANSWERED;
            }

            this.ringtone.pause();
        },
        terminate() {
            this.isEnding = true;

            if (this.call) {
                this.call.hangup();
            }
            this.beeps.pause();
            this.ringtone.pause();
        },
        muteAudio() {
            if (this.call) {
                this.call.muteAudio();
                this.isAudioMuted = true;
            }
        },
        unmuteAudio() {
            if (this.call) {
                this.call.unmuteAudio();
                this.isAudioMuted = false;
            }
        },
        muteVideo() {
            if (this.call) {
                this.call.muteVideo();
                this.isVideoMuted = true;
            }
        },
        unmuteVideo() {
            if (this.call) {
                this.call.unmuteVideo();
                this.isVideoMuted = false;
            }
        },
        toggleVideoMute() {
            if (this.isEstablished) {
                if (this.isVideoMuted) {
                    this.unmuteVideo();
                    this.onCameraOn();
                } else {
                    this.muteVideo();
                    this.onCameraOff();
                }
            }
        },
        toggleAudioMute() {
            if (this.isAudioMuted) {
                this.unmuteAudio();
            } else {
                this.muteAudio();
            }
        },
        cleanUp() {
            this.ringtone.pause();
            this.beeps.pause();
            const cameraStatus = 'off';
            this.$store.dispatch('conversation/toggleAgentCamera', { cameraStatus });
            this.call = null;

            this.from = null;
            this.to = null;

            this.inboxId = null;
            this.conversationId = null;

            this.seconds = 0;

            if (this.intervalId) {
                clearInterval(this.intervalId);
            }

            this.intervalId = null;
            this.callStatusType = null;
            this.callId = null;
            this.callSID = null;

            this.isIncoming = false;
            this.isOutgoing = false;

            this.isScreenShare = false;
            this.localStream =  null;
            this.remoteStream = null;

            this.remoteVideoState = null;

            this.isEnding = false;

            this.remoteVideoTop = 60;
            this.remoteVideoLeft = this.innerWidth/2 - 260;
            this.selfVideoTop = this.innerHeight - 180;
            this.selfVideoLeft = this.innerWidth - 220;


            const remoteAudio = document.getElementById("remote-audio");
            const remoteVideo = document.getElementById("remote-view");
            const selfVideo = document.getElementById("self-view");

            remoteAudio.srcObject = null;
            remoteVideo.srcObject = null;
            selfVideo.srcObject = null;

            this.isAudioMuted = false;
            this.isVideoMuted = true;
        },

        updateSeconds() {
            this.seconds = this.seconds + 1;
        },
        async updateCall(payload) {
            const response = await callsAPI.updateCall(this.callId, payload);
        },
        minimizeSelfVideo(){
            this.selfVideoState = selfVideoStateTypes.MINIMIZED;
        },
        toNormalSelfVideo() {
            this.selfVideoState = selfVideoStateTypes.NORMAL;
        },
        minimizeRemoteVideo(){
            this.remoteVideoState = remoteVideoStateTypes.MINIMIZED;
        },
        toNormalRemoteVideo() {
            this.remoteVideoState = remoteVideoStateTypes.NORMAL;
        },
        maximizedRemoteVideo() {
            if (this.isMaximizedState || this.isMinimizedState) {
                this.remoteVideoState = remoteVideoStateTypes.NORMAL;
            } else {
                this.remoteVideoState = remoteVideoStateTypes.MAXIMIZED;
            }
        },
        onResize() {
            this.innerHeight = window.innerHeight
            this.innerWidth = window.innerWidth;
        },
        moveRemoteVideo(e) {
          if (!this.isMaximazedState){
            this.innerVideoTop = e.clientY;
            this.innerVideoLeft = e.clientX;
            e.preventDefault();
            this.activeRemote = true;
          }
        },
        moveSelfVideo(e) {
          if (!this.isMaximazedState){
            this.innerVideoTop = e.clientY;
            this.innerVideoLeft = e.clientX;
            e.preventDefault();
            this.activeSelf = true;
          }
        }
    }
}
</script>

<style scoped>
.sip-endpoint-widget__controls-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    align-content: center;
}

.sip-endpoint-widget__controls-wrapper--mobile {
    display: none;
}

.sip-endpoint-widget__button {
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    margin-right: 20px;
    width: 40px;
    padding: 10px;
    border-radius: 50%;
    cursor: pointer;
}

.sip-endpoint-widget__button:active {
    transform: scale(0.8);
}

.sip-endpoint-widget__call-button {
    background-color: #44ce4b;
}

.sip-endpoint-widget__decline-button {
    background-color: #ff382d;
}

.sip-endpoint-widget__mute-audio-button {
    background-color: #1f93ff;
}

.sip-endpoint-widget__mute-audio-button--active {
    background-color: #ff382d;
}

.sip-endpoint-widget__self-view {
    width: 160px;

    height: 120px;

    border-radius: 10px;

    box-shadow: rgba(0, 0, 0, 0.24) 0 3px 8px;

    background-color: transparent;
}
.sip-endpoint-widget__self-view--minimized {
    width: 160px;

    height: 60px;

    border-radius: 10px;

    box-shadow: rgba(0, 0, 0, 0.24) 0 3px 8px;

    background-color: transparent;
}

.sip-endpoint-widget__call-button--inactive {
    background-color: gray;
}

/* NEW STYLE */

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
    opacity: 0;
}

.incoming-call-wrapper {
    position: fixed;

    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    display: flex;

    justify-content: center;
    align-content: center;
    align-items: center;

    background-color: rgba(0, 0, 0, 0.4);

    z-index: 2000;
}

.incoming-call-box {
    width: 300px;

    display: flex;
    flex-direction: column;

    justify-content: center;
    align-content: center;
    align-items: center;

    border-radius: 10px;
    overflow: hidden;
}

.incoming-call-box__header {
    width: 100%;

    display: flex;

    justify-content: center;
    align-content: center;
    align-items: center;

    font-size: 20px;

    background-color: #3C3D40;

    padding: 10px 0;

    color: white;
}

.incoming-call-box__from {
    width: 100%;

    display: flex;

    justify-content: center;
    align-content: center;
    align-items: center;

    background-color: #ffffff;

    color: black;

    height: 100px;


}

.incoming-call-box__from-inside {
    width: 300px;
    padding: 20px;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    font-size: 24px;
    color: #3C3D40;

    text-align: center;
}

.incoming-call-box__actions {
    background-color: #E9EAEF;
    width: 100%;

    display: flex;

    justify-content: space-between;
    align-items: center;
    align-content: center;

    padding: 15px;
}

.incoming-call-box__button {
    border-radius: 10px;

    padding: 8px;

    display: flex;

    justify-content: center;
    align-content: center;
    align-items: center;

    cursor: pointer;
}

.incoming-call-box__button:active {
    transform: scale(0.9);
}

.incoming-call-box__accept-button {
    background-color: #60CE4D;
    width: 45%;
}

.incoming-call-box__decline-button {
    background-color: #ED4948;
    width: 45%;
}

.self-video-wrapper {
    position: fixed;

    border-radius: 10px;

    width: 160px;
    max-height: 120px;

    background-color: black;

    z-index: 2003;
}

.self-video-wrapper--maximized {
    bottom: 20px;
}
.self-video-wrapper--normal {
  position: fixed;

  border-radius: 10px;

  width: 160px;
  height: 120px;

  background-color: black;

  z-index: 2003;
}

.self-video-wrapper--minimized {
  position: fixed;

  border-radius: 10px;

  width: 160px;
  height: 60px;

  background-color: black;

  z-index: 2003;
}

.fade-remote-video-enter-active, .fade-remote-video-leave-active {
    transition: opacity .5s;
}

.fade-remote-video-enter-active {
    transition-delay: 3s;
}

.fade-remote-video-enter, .fade-remote-video-leave-to /* .fade-leave-active below version 2.1.8 */
{
    opacity: 0;
}

.remote-video-wrapper--normal {
    position: fixed;

    border-radius: 10px;

    z-index: 2000;

    background-color: black;

    width: 520px;
    height: 390px;
}

.remote-video-wrapper--minimized {
    position: fixed;

    border-radius: 10px;

    height: 60px;
    width: 160px;

    z-index: 2000;

    background-color: black;
}

.remote-video-wrapper--maximized {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;

    max-width: 100vw;
    max-height: 100vh;

    background-color: black;

    z-index: 2000;
}

.sip-endpoint__remote-view {
    width: 520px;
    height: 390px;
    position: absolute;
    border-radius: 10px;

    box-shadow: rgba(0, 0, 0, 0.24) 0 3px 8px;

    background-color: transparent;
}

.sip-endpoint__remote-view--minimized {
    width: 160px;
    position: absolute;
    height: 60px;

    box-shadow: rgba(0, 0, 0, 0.24) 0 3px 8px;
}

.sip-endpoint__remote-view--maximized {
    z-index: 2001;

    border-radius: 0;
}

.sip-endpoint__remote-view-off {
    width: 520px;
    height: 390px;
    position: absolute;
    border-radius: 10px;
    text-align: center;
    z-index: 2002;
    display: flex;
    flex-direction: column;
    color: white;
    font-size: 20pt;
    align-items: center;
    justify-content: center;
    box-shadow: rgba(0, 0, 0, 0.24) 0 3px 8px;

    background-color: #a5c3c9;
}

.sip-endpoint__remote-view-off--minimized {
    width: 160px;
    display: flex;
    flex-direction: column;
    color: white;
    font-size: 20pt;
    text-align: center;
    align-items: center;
    justify-content: center;
    position: absolute;
    height: 60px;
    z-index: 2002;
    box-shadow: rgba(0, 0, 0, 0.24) 0 3px 8px;
    background-color: #a5c3c9;
}

.sip-endpoint__remote-view-off--maximized {
    z-index: 2002;
    display: flex;
    flex-direction: column;
    color: white;
    font-size: 20pt;
    align-items: center;
    justify-content: center;
    text-align: center;
    background-color: #a5c3c9;
    border-radius: 0;
}

.remote-video__actions {
    display: none;
    width: 100px;

    justify-content: space-between;
    align-items: center;
    align-content: center;

    position: absolute;

    right: 10px;
    top: 10px;

    cursor: pointer;

    z-index: 2003;
}

.remote-video-wrapper--normal:hover .remote-video__actions{
    display: flex;
}

.remote-video-wrapper--minimized:hover .remote-video__actions{
    display: flex;
}

.remote-video-wrapper--maximized:hover .remote-video__actions{
    display: flex;
}

.remote-video__actions--mobile {
    display: none;
}

.remote-video__action {
    padding: 10px;

    border-radius: 50%;

    background-color: rgba(0, 0, 0, 0.2);

    margin-right: 10px;
}

.remote-video__action:hover {
    background-color: rgba(255, 255, 255, 0.3);
}
.self-video__actions {
    display: none;
    width: 100px;

    justify-content: space-between;
    align-items: center;
    align-content: center;

    position: absolute;

    right: 10px;
    top: 10px;

    cursor: pointer;

    z-index: 2003;
}

.self-video-wrapper--normal:hover .self-video__actions{
    display: flex;
}

.self-video-wrapper--minimized:hover .self-video__actions{
    display: flex;
}

.self-video__action {
    padding: 10px;

    border-radius: 50%;

    background-color: rgba(0, 0, 0, 0.2);

    margin-right: 10px;
}

.self-video__action:hover {
    background-color: rgba(255, 255, 255, 0.3);
}

.remote-video__action--mobile {
    display: none;
}
.self-video__action--mobile {
    display: none;
}

.sip-endpoint__controls-wrapper {
    position: fixed;

    bottom: 20px;
    left: calc(50% - 300px);

    width: 600px;

    background-color: #1F2D3D;

    color: white;

    border-radius: 15px;


    font-size: 16px;

    font-weight: 600;

    padding: 15px;

    z-index: 2005;

    display: none;
}

.sip-endpoint__controls-wrapper--maximized {
    opacity: 0;

    transition: opacity;

    transition-duration: 1s;

    display: block;
}

.sip-endpoint__controls-wrapper--maximized:hover {
    opacity: 1;
}

.sip-endpoint__controls-wrapper--mobile {
    position: fixed;

    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;

    border-radius: 0;

    display: block;
}

.sip-endpoint-dialog__established-controls {
    width: 100%;

    display: flex;

    align-items: center;
    align-content: center;
    justify-content: space-between;
}

.established-controls__from {
    margin-right: 20px;

    width: 150px;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    text-align: center;
}

.established-controls__from--mobile {
    display: none;
}

.established-controls__time {
    width: 90px;

    margin-right: 20px;
}

.established-controls__buttons-wrapper {
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: space-between;
}

.established-controls__mute-icon-wrapper {
    padding: 10px;

    background-color: #40A2F7;

    margin-right: 20px;

    border-radius: 50%;

    cursor: pointer;
}

.established-controls__mute-icon-wrapper:active {
    transform: scale(0.9);
}

.established-controls__mute-icon-wrapper.established-controls__mute-icon-wrapper--active {
    background-color: #ED4948;
}

.established-controls__decline-icon-wrapper {
    padding: 5px;

    width: 100px;

    border-radius: 10px;

    display: flex;

    align-items: center;
    align-content: center;
    justify-content: center;

    cursor: pointer;

    background-color: #ED4948;
}

.established-controls__decline-icon-wrapper:active {
    transform: scale(0.9);
}

.the-relay-sip-endpoint-widget-global-wrapper {
    position: fixed;

    right: 20px;

    top: 16px;

    z-index: 2005;
}

.the-relay-sip-endpoint-widget-global-wrapper--mobile {
    right: 60px;
}


</style>
